import f from "./ghl-ui.es1311.js";
import m from "./ghl-ui.es1312.js";
import i from "./ghl-ui.es1291.js";
import e from "./ghl-ui.es1313.js";
function a(o, d, r) {
  return o = i(o), d = r ? void 0 : d, d === void 0 ? m(o) ? e(o) : f(o) : o.match(d) || [];
}
export {
  a as default
};
